import HoveredButton from "./HoveredButton";

export default class NoFavoriteOrRecentOrders extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        $(document).ready(function () {
            $('.no-fav-container a.start-fav-btn').click(function (e) {
                var cind = $(this).parent(".nav-item").index();
                var target = $(this).data("target");
                if (target.startsWith("#")){
                    var anchorTab = $(this).closest(".common-tabs").siblings(".tab_container").find('a[href="' + target + '"]');
                    anchorTab.click();
                }
                else{
                    $(location).attr('href', target);
                }
            })
        })
    }
    render() {
        return (
            <div className="no-fav-container text-center w-100">
                <div className="no-fav-content-container">
                    <div className="iHop-Gotham fav-h4 h4">{this.props.title}</div>
                    <p className="no-fav-para">{this.props.subTitle}</p>                   
                    <a href="#" data-target={this.props.target} className="start-fav-btn" role="button">{this.props.buttonText}</a>
                </div>
            </div>       
        );
    }
}
